export default __webpack_public_path__ + "35e4b7aed977852f94e3813746540b48.jpg";